export default __webpack_public_path__ + "static/header-dc901b4e9c7d1bff5170db4616f988cd.mp4";